// frontend/src/lib/safety-reminder-seen.ts
import AsyncStorage from '@react-native-async-storage/async-storage';

// Presentation-only, client-side tracking of which Connections this
// device has already shown the mandatory safety-reminder screen for --
// design.md's Design Principle 5 explicitly carves out "which screen to
// show" as legitimate client-side state, unlike any actual safety
// enforcement (which stays server-side). The recipient side already sees
// the reminder unconditionally at the moment they accept (issue #16),
// wired directly as that mutation's onSuccess navigation -- a true
// one-shot event with nothing to persist. The requester has no
// equivalent one-shot action to hang the reminder off, since accept is
// unilateral by the recipient (issue #103): this file exists so the
// requester is shown it exactly once too, the next time they open the
// app and discover the request they sent is now mutual.
const STORAGE_KEY = '@nearkin/safety-reminder-seen-connection-ids';

export async function getSeenSafetyReminderConnectionIds(): Promise<Set<string>> {
  const raw = await AsyncStorage.getItem(STORAGE_KEY);
  if (!raw) return new Set();

  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? new Set(parsed.filter((id): id is string => typeof id === 'string')) : new Set();
  } catch {
    return new Set();
  }
}

export async function markSafetyReminderSeen(connectionId: string): Promise<void> {
  const seen = await getSeenSafetyReminderConnectionIds();
  seen.add(connectionId);
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify([...seen]));
}
